/** @jsx jsx */
import { memo, useMemo } from 'react';
import { jsx } from '@emotion/core';
import Button from '@atlaskit/button/standard-button';
import ArrowleftIcon from '@atlaskit/icon/glyph/chevron-left-large';
import ArrowrightIcon from '@atlaskit/icon/glyph/chevron-right-large';
import { N70 } from '@atlaskit/theme/colors';
import { arrowLeftButtonStyle, arrowRightButtonStyle, monthAndYearStyle as getMonthAndYearStyle, headingStyle } from '../styles/heading';
const Heading = /*#__PURE__*/memo(function Heading({
  monthLongTitle,
  year,
  handleClickPrev,
  handleClickNext,
  mode,
  testId
}) {
  const monthAndYearStyle = useMemo(() => getMonthAndYearStyle(mode), [mode]);
  return jsx("div", {
    css: headingStyle,
    "aria-hidden": "true"
  }, jsx(Button, {
    css: arrowLeftButtonStyle,
    appearance: "subtle",
    spacing: "none",
    tabIndex: -1,
    onClick: handleClickPrev,
    testId: testId && `${testId}--previous-month`,
    iconBefore: jsx(ArrowleftIcon, {
      label: "Last month",
      size: "medium",
      primaryColor: N70
    })
  }), jsx("div", {
    css: monthAndYearStyle,
    "data-testid": testId && `${testId}--current-month-year`
  }, `${monthLongTitle} ${year}`), jsx(Button, {
    css: arrowRightButtonStyle,
    appearance: "subtle",
    spacing: "none",
    tabIndex: -1,
    onClick: handleClickNext,
    testId: testId && `${testId}--next-month`,
    iconBefore: jsx(ArrowrightIcon, {
      label: "Next month",
      size: "medium",
      primaryColor: N70
    })
  }));
});
Heading.displayName = 'Heading';
export default Heading;